module.exports = __webpack_public_path__ + "img/fal-circle-play.dc65c2df.svg";